<div>
  <ng-container>
    <div class="light-content-box">
      <h2 class="box-title">Check for available Auto plans.</h2>
      <form [formGroup]="eligibilityForm">
        <div class="input-wrapper">
          <app-simple-input
            [labelText]="'Verizon phone number'"
            [inputType]="'text'"
            [inputId]="'phone'"
            [controlName]="'phone'"
            [parentForm]="eligibilityForm">
          </app-simple-input>
        </div>
        <div class="input-wrapper">
          <app-simple-input
            [labelText]="'ZIP code on billing address'"
            [inputType]="'text'"
            [inputId]="'zip'"
            [controlName]="'zip'"
            [parentForm]="eligibilityForm">
          </app-simple-input>
        </div>
        <div class="button-box">
          <app-main-button
            (onClick)="onCheckEligibility()"
            [buttonWidth]="'100%'"
            [textColor]="'#FFFFFF'"
            [backgroundColor]="'#000000'"
            [buttonText]="'Check eligibility'">
          </app-main-button>
        </div>
      </form>
    </div>
  </ng-container>
</div>
